import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=3c02b1d6&scoped=true&"
import script from "./ProfilePopup.vue?vue&type=script&lang=ts&"
export * from "./ProfilePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=3c02b1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c02b1d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
